// extracted by mini-css-extract-plugin
export default {"container":"GamePage_container__KxwXG","titleBlock":"GamePage_titleBlock__imJ48","title":"GamePage_title__-U68e"};